import React, { useState } from 'react';
import { Modal, Input, Button, message } from 'antd';

interface OtpVerificationModalProps {
  visible: boolean;
  onVerify: (otp: string) => void;
  onCancel: () => void;
}

export const OtpVerificationModal: React.FC<OtpVerificationModalProps> = ({
  visible,
  onVerify,
  onCancel
}) => {
  const [otp, setOtp] = useState('');

  const handleVerify = () => {
    if (otp.length === 6) {
      onVerify(otp);
    } else {
      message.error('Please enter a valid 6-digit OTP');
    }
  };

  return (
    <Modal
      title="Verify OTP"
      visible={visible}
      onCancel={onCancel}
      centered
      width="90%"
      style={{ maxWidth: '500px' }}
      footer={[
        <Button key="cancel" onClick={onCancel} block style={{ marginBottom: '8px' }}>
          Cancel
        </Button>,
        <Button key="verify" type="primary" onClick={handleVerify} block>
          Verify
        </Button>
      ]}
    >
      <div style={{ padding: '8px 0' }}>
        <p style={{ marginBottom: '16px', fontSize: '14px', lineHeight: '1.5' }}>
          Please enter the 6-digit OTP sent to your registered mobile number or email:
        </p>
        <Input
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          maxLength={6}
          placeholder="Enter 6-digit OTP"
          size="large"
          style={{ fontSize: '18px', textAlign: 'center', letterSpacing: '0.5em' }}
        />
      </div>
    </Modal>
  );
};
